import { Table, TableColumnsType } from "antd";
import { FC, useState } from "react";
import { useTranslation } from 'react-i18next';
import config from "../../../lib/config";
import { IGaSite } from "../../../models/ga.model";
import Pagination from "../../Pagination";

interface IProps {
  data: IGaSite[]|undefined;
}

const PageStats: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const pageSize = 7;

  const columns: TableColumnsType<IGaSite> = [
    {
      title: 'URL',
      dataIndex: 'path',
      key: 'path',
      align: 'center',
      render: value => value.length > 40 ? `${value.slice(0, 40)}...` : value,
    },
    {
      title: t('class.dashboard.column18'),
      dataIndex: 'viewCount',
      key: 'viewCount',
      align: 'center',
      render: value => value?.toLocaleString(),
    },
    {
      title: t('class.dashboard.column19'),
      dataIndex: 'avgViewCount',
      key: 'avgViewCount',
      align: 'center',
      render: (value, record) => {
        return Math.trunc(record.viewCount / value  * 10) / 10;
      },
    },
  ];

  return (
    <>
      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: pageSize,
          }}
        />
      </div>
      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination
            count={data?.length || 0}
            page={page}
            setPage={setPage}
            mini
            perPage={pageSize}
          />
        </div>
      </div>
    </>
  );
}

export default PageStats;
